module.exports = __webpack_public_path__ + "img/vegas.6b1dcbf0.jpg";